import React, { FormEvent, useState } from 'react';
import {
  Layout,
  Input,
  Radio,
  Loading,
  Icon,
  Button,
  Select,
} from '@oscar/theme';
import { TextField } from 'common/components';
import { ActionField, Field, useFormContext } from '@oscar/form';
import FormList from 'common/components/FormList';
import { APIS } from 'common/constants/endpoints';
import { SearchResult } from './SearchResult';
import CreateForm from './CreateForm';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import { SAP_STATUS_LIST } from 'common/constants/insulation';
import { REQUEST_STATUS } from 'common/constants';
import apiClient from '@oscar/request';
import crypto from 'crypto';

import '../style.scss';
import moment from 'moment';
import { FORMAT_DATE } from 'common/constants';
import { FormContext } from '@oscar/form/dist/formContext';

const { Option } = Select;

export interface SteelNotification {
  id: string;
  steelId: string;
  scaffoldId: string;
  scaffoldRefNo: string;
  status: number;
  jobDescription: string;
  functionalLocation: string;
  locationDescription: string;
  startDate: string | any;
  endDate: string | any;
  isLocal?: boolean;
}

const isReadOnly = (statusRequest?: StatusInstance) => {
  return statusRequest?.state === 'VIEW';
};
const mapData = (status: any) => {
  for (const key in REQUEST_STATUS) {
    if (status === REQUEST_STATUS[key as keyof typeof REQUEST_STATUS].VALUE) {
      return REQUEST_STATUS[key as keyof typeof REQUEST_STATUS].TEXT;
    }
  }
};

const SearchContent = (props: any) => {
  const { setItem, valueSearchRequest, setValueSearchRequest } = props;
  const [errorSearchInput, setErrorSearchInput] = useState(false);

  const [searchType, setSearchType] = useState('scaffoldId'); //Default
  const [formContext] = useFormContext();

  const changeDescription = () => {
    return searchType === 'scaffoldId'
      ? 'Already created a Scaffolding Request in SiSFolds? Search the SiSFolds ID No. here'
      : 'Already created a Scaffolding Request in Steel? Search the Steel ID No. here';
  };

  const handleSync = () => {
    return apiClient
      .request({
        method: 'POST',
        url: APIS.SYNC_SCAFFOLD,
      })
      .then(res => {
        alert('Successfully Sync');
        console.log(res);
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  };
  return (
    <Layout.Content>
      <span style={{ marginRight: '10px' }}>Search by</span>
      <Select
        defaultValue="scaffoldId"
        style={{ width: 250 }}
        onChange={value => {
          setSearchType(value);
          // props.setSearchType(value);
        }}
      >
        <Option value="scaffoldId">SiSFolds ID</Option>
        <Option value="steelId">Steel ID</Option>
      </Select>
      {searchType === 'scaffoldId' && (
        <Button
          type="secondary"
          size="small"
          onClick={handleSync}
          style={{ marginLeft: '10px' }}
        >
          Sync Scaffold
        </Button>
      )}
      <div className="search-container">
        <div className="description">{changeDescription()}</div>
        <ActionField
          name="searchNotification"
          onResponseData={res => {
            if (res?.status === 204) {
              setItem?.({
                [searchType === 'scaffoldId' ? 'scaffoldId' : 'steelId']:
                  valueSearchRequest,
                isLocal: true,
              });
            } else {
              setItem?.(res);
            }
          }}
          request={{
            name: searchType === 'scaffoldId' ? 'scaffoldId' : 'steelId',
            method: 'GET',
            url:
              searchType === 'scaffoldId'
                ? APIS.SCAFFOLD_SEARCH
                : APIS.STEEL_SEARCH,
            nextParams: (nextProps: any) => {
              return {
                [searchType === 'scaffoldId' ? 'scaffoldId' : 'steelId']:
                  valueSearchRequest,
              };
            },
          }}
        >
          {(searchProps: any) => {
            const handleSearch = () => {
              if (
                valueSearchRequest &&
                valueSearchRequest?.replace(/\s/g, '')?.length >= 8
              ) {
                if (searchType === 'scaffoldId') {
                  searchProps?.submitData({ id: valueSearchRequest }, true);
                  formContext.form?.setFieldsValue({ searchType: searchType });
                  console.log(formContext.form?.getFieldValue('searchType'));
                } else {
                  searchProps?.submitData({ id: valueSearchRequest }, true);
                }
              } else {
                setItem?.({
                  [searchType === 'scaffoldId' ? 'scaffoldId' : 'steelId']:
                    valueSearchRequest,
                  isLocal: true,
                });
              }
            };

            return (
              <>
                <Input
                  prefix={
                    searchProps?.isLoading ? (
                      <Loading />
                    ) : (
                      <Button type="link" size="small" onClick={handleSearch}>
                        <Icon icon="search" />
                      </Button>
                    )
                  }
                  placeholder={
                    searchType === 'scaffoldId' ? 'SisFold ID' : 'Steel ID'
                  }
                  size={'large'}
                  maxLength={15}
                  value={valueSearchRequest}
                  onChange={(event: FormEvent<HTMLInputElement>) => {
                    setValueSearchRequest(event.currentTarget.value);
                  }}
                  onPressEnter={handleSearch}
                />
              </>
            );
          }}
        </ActionField>
      </div>
    </Layout.Content>
  );
};

const SteelNotificationItem = (item: SteelNotification) => {
  return (
    <TextField
      label={item?.scaffoldRefNo}
      value={() => mapData(item?.status)}
      //mappingData={SAP_STATUS_LIST}
      primary
    />
  );
};

function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  const buf = Buffer.allocUnsafe(4); // buffer size is based on int32
  crypto.randomFillSync(buf);
  let num = buf.readUInt32BE(0);
  num = Math.floor(num % (max - min + 1)) + min;
  return num;
}

const getRandomID = () => {
  let randNum = '';
  for (let i = 0; i < 8; i++) {
    randNum += getRandomInt(0, 9);
  }
  return parseInt(randNum);
  //return Math.floor(Math.random() * (99999999 - 10000000)) + 10000000;
};

const CreateButton = () => {
  const sisfoldCreateURL = process.env.REACT_APP_CREATE_SCAFFOLD_URL;
  return (
    <Button
      className="create-button"
      type="secondary"
      size="middle"
      onClick={() => {
        window.open(sisfoldCreateURL, 'scaffold', 'noopener');
      }}
      style={{ marginBottom: '10px' }}
    >
      CREATE NEW
    </Button>
  );
};
interface Props {
  statusRequest?: StatusInstance;
}
export default ({ statusRequest }: Props) => {
  return (
    <div className="scaffold-detail">
      {statusRequest?.state === 'EDIT' && (
        <div className="search-required">
          <div className="search-required-text">Scaffolding Require</div>
          <Field name="isScaffoldingRequire">
            <Radio.Group disabled={true}>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Field>
        </div>
      )}
      <FormList<SteelNotification>
        keyField="scaffoldId"
        title="SiSFolds ID"
        name="listScaffoldDetail"
        headerComponent={
          statusRequest?.state === 'EDIT' ? SearchContent : undefined
        }
        createButtonComponent={CreateButton}
        detailComponent={SearchResult}
        onItemRenderer={SteelNotificationItem}
        defaultValueAdded={() => {
          return {
            scaffoldId: getRandomID().toString(),
            status: 3,
            endDate: moment(),
            startDate: moment(),
          };
        }}
        addedComponent={CreateForm}
        // readOnly={statusRequest?.state === 'VIEW'}
        readOnly={isReadOnly(statusRequest)}
      />
    </div>
  );
};
